import axios from 'axios'
import { environment } from './consts/environment'
import { CHART_DATA_EXAMPLE } from './consts/chartExampleData'
import { ChartOriginalData } from 'interfaces'
import { PORTFOLIO_EXAMPLE, VIEWS_EXAMPLE } from './consts/exampleUser'

const selfUrl = `${environment.appUrl}/api`
/**
 * Returns list of blocked usernames
 */
export const getBlockedRoutes = async () => {
  try {
    const res = await axios.post(`${selfUrl}/blocked-routes`)
    return res.data
  } catch (error) {
    if (environment.env === 'development') {
      console.error(error)
    }

    return []
  }
}

const simulateRequest = <T>(data: T): Promise<T> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data)
    }, 1000)
  })
}
// Example request chart data
export const getChartData = async (
  chart: string,
  time: string
): Promise<ChartOriginalData> => {
  const filterData = CHART_DATA_EXAMPLE[chart].options.find(
    (item: ChartOriginalData) => {
      return item.optionLabel === time
    }
  )
  return await simulateRequest(filterData)
}
const cacheSimulated = []
export const getCampaingById = async (id: string) => {
  const existsCampaing = cacheSimulated.find((item) => item.id === id)
  if (existsCampaing) {
    return existsCampaing
  }
  const campaing = PORTFOLIO_EXAMPLE.find((item) => item.id === id)
  cacheSimulated.push(campaing)
  return await simulateRequest(campaing)
}

// Example view request
export const getViews = async (news = false, page = 1, limit = 5) => {
  const views = VIEWS_EXAMPLE.filter((item) => {
    const date = new Date(item.date)
    const today = new Date()
    if (news) {
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      )
    }
    return date.getDate() !== today.getDate()
  })
  const total = views.length

  return await simulateRequest({
    total,
    views: views.slice((page - 1) * limit, page * limit),
  })
}
